import { render, staticRenderFns } from "./new-leads.vue?vue&type=template&id=2ba91a9e&scoped=true"
import script from "./new-leads.vue?vue&type=script&lang=js"
export * from "./new-leads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba91a9e",
  null
  
)

export default component.exports